import React from 'react';
import { number, string, func } from 'prop-types';
import { Link } from 'react-router-dom';

// Import components
import { ReactComponent as PlayIcon } from 'assets/icons/vod_play.svg';
import GradientButton from './GradientButton';

// Import styles
import { Root } from './styles';

// Import hooks
import { useDetailsButton } from './hooks';

export function DetailButton({
	uuid,
	width,
	height,
	subtype,
	redirect,
	title = '',
	GTMEvent
}) {
	const { handleRedirect, linkRedirect, buttonText, ref } = useDetailsButton({
		uuid,
		title,
		subtype,
		redirect,
		GTMEvent
	});

	return (
		<Root
			as={Link}
			onClick={handleRedirect}
			width={width}
			height={height}
			to={linkRedirect}
			ref={ref}
		>
			<GradientButton
				ref={ref}
				text={buttonText}
				icon={<PlayIcon stroke="#fff" height="1.2em" />}
			/>
		</Root>
	);
}

DetailButton.defaultProps = {
	width: 189,
	height: 59,
	subtype: '',
	redirect: () => {}
};

DetailButton.propTypes = {
	uuid: string.isRequired,
	width: number,
	height: number,
	subtype: string,
	title: string,
	GTMEvent: func.isRequired
};
